<div class="p-5 flex flex-col h-[90vh] animate-fade">
    <div class="border rounded-xl shadow p-5 w-full flex flex-col justify-end h-full">
        <div class="flex-grow rounded-md border border-gray-300 p-5 overflow-y-auto shadow-gray-200 shadow-lg">
            <div #contentChat *ngFor="let chat of chats" class="animate-fade">
                <div *ngIf="chat.tipo === 'Usuario'" class="flex justify-end">
                    <div class="bg-azul text-white p-3 rounded-lg w-1/2 m-2 whitespace-pre-line">
                        {{chat.mensaje}}
                    </div>
                </div>
                <div class="flex">
                    <div *ngIf="chat.tipo === 'IA'" class="bg-gray-200 text-black p-3 rounded-lg w-1/2 m-2">
                        {{chat.mensaje}}
                    </div>
                </div>
            </div>
            <div *ngIf="cargando" class="flex items-center gap-1 mt-2">
                <span class="text-sm text-black italic">{{ 'generando-dieta' | translate }}</span>
                <div class="flex flex-row gap-2">
                <div class="w-2 h-2 rounded-full bg-azul animate-bounce"></div>
                <div class="w-2 h-2 rounded-full bg-azul animate-bounce [animation-delay:-.3s]"></div>
                <div class="w-2 h-2 rounded-full bg-azul animate-bounce [animation-delay:-.5s]"></div>
                </div>
            </div>
        </div>
        <div class="bg-gray-200 p-5 rounded-md grid grid-cols-[1fr_auto] gap-4 items-center mt-2 shadow-gray-200 shadow-lg">
            <input (keydown.enter)="mandarMensaje(mensaje)" [(ngModel)]="mensaje" type="text" class="outline-none border-none focus:outline-none focus:ring-0 bg-transparent w-full" placeholder="{{'introduce-mensaje' | translate}}"/>
            <a (click)="mandarMensaje(mensaje)" type="button" class="bg-azul text-white w-10 h-10 rounded-full flex items-center justify-center shadow-md hover:text-blue-300 duration-1000
            shadow-gray-600 transition ease-in-out hover:-translate-y-2">
                <mat-icon>arrow_upward</mat-icon>
            </a>
        </div>
        <div class="mt-2 grid grid-cols-3 gap-4">
            <div class="relative col-span-1">
                <!-- Botón -->
                <button type="button" (click)="abrirInputPeso()" class="w-full rounded-lg px-3 py-1 bg-azul text-white text-sm text-center hover:text-blue-300 duration-1000">
                    {{ 'peso' | translate }}
                </button>
                <input *ngIf="abiertoPeso" type="number" id="peso" placeholder="Peso en kg" [(ngModel)]="peso" class=" mt-2 w-full border border-gray-300 rounded-md px-3 py-2 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
            </div>
            <div class="relative col-span-1">
                <!-- Botón -->
                <button type="button" (click)="abrirInputAltura()" class="w-full rounded-lg px-3 py-1 bg-azul text-white text-sm text-center hover:text-blue-300 duration-1000">
                    {{ 'altura' | translate }}
                </button>
                <input *ngIf="abiertoAltura" type="number" id="altura" placeholder="Altura en cm" [(ngModel)]="altura" class=" mt-2 w-full border border-gray-300 rounded-md px-3 py-2 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"/>
            </div>
            <div class="relative col-span-1">
                <!-- Botón -->
                <button type="button" (click)="abrirSelectAlergias()" class="w-full rounded-lg px-3 py-1 bg-azul text-white text-sm text-center hover:text-blue-300 duration-1000">
                    {{ 'alergias' | translate }}
                </button>
                <!-- Dropdown -->
                <div *ngIf="abiertoAlergias" class="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-md max-h-60 overflow-y-auto">
                    <ul class="p-2 space-y-2 text-sm" *ngIf="translate.currentLang == 'es'">
                        <li *ngFor="let alergia of alergias">
                            <label class="flex items-center space-x-2">
                                <input type="checkbox" [checked]="estaSeleccionada(alergia)" (change)="seleccionarAlergia(alergia)" class="form-checkbox text-blue-600 rounded"/>
                                <span>{{ alergia }}</span>
                            </label>
                        </li>
                    </ul>
                    <ul class="p-2 space-y-2 text-sm" *ngIf="translate.currentLang == 'gb'">
                        <li *ngFor="let alergia of allergiesEng">
                            <label class="flex items-center space-x-2">
                                <input type="checkbox" [checked]="estaSeleccionada(alergia)" (change)="seleccionarAlergia(alergia)" class="form-checkbox text-blue-600 rounded"/>
                                <span>{{ alergia }}</span>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
